import { useSyncExternalStore } from 'react';

import type { DeviceType } from '@repo/ui/utils/breakpoints';
import { BREAKPOINTS } from '@repo/ui/utils/breakpoints';

export function getDeviceTypeFromWidth(width: number): DeviceType {
  if (width <= BREAKPOINTS.MOBILE) return 'mobile';
  if (width < BREAKPOINTS.DESKTOP) return 'tablet';
  return 'desktop';
}

export interface DeviceTypeResult {
  deviceType: DeviceType;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isMobileOrTablet: boolean;
}

export const useWindowWidth = (): number =>
  useSyncExternalStore(subscribeToWindowResize, getWindowWidth, getServerWidth);

export const useDeviceType = (): DeviceTypeResult => {
  const width = useWindowWidth();
  const deviceType = getDeviceTypeFromWidth(width);

  return {
    deviceType,
    isMobile: deviceType === 'mobile',
    isTablet: deviceType === 'tablet',
    isDesktop: deviceType === 'desktop',
    isMobileOrTablet: deviceType === 'mobile' || deviceType === 'tablet',
  };
};

function subscribeToWindowResize(onStoreChange: () => void): () => void {
  window.addEventListener('resize', onStoreChange);
  return () => window.removeEventListener('resize', onStoreChange);
}

function getWindowWidth(): number {
  return window.innerWidth;
}

function getServerWidth(): number {
  return Number.POSITIVE_INFINITY;
}
